import { useContext } from 'react'
import { hubAppCopyContext } from '../contexts'
import createTranslationFunc from '../utils/createTranslationFunc'

// An easy way to access the app copy context

function useHubAppCopy() {
  const hubAppCopyObject = useContext(hubAppCopyContext)
  return createTranslationFunc(hubAppCopyObject)
}

export default useHubAppCopy
